import { useRSStore } from '../store/useRSStore'
import { readAppListAPI, updateShowAppAPI, updateNoteAppAPI, deleteAppAPI, apkUploadAPI, paginationAppAPI } from '../api/AppAPI'

import type { appfilter, updateshowapp, updatenoteapp, apkUpload } from '../types/types'

export function useApp() {
  const RSStore = useRSStore()
  const onReadAppList = async (appfilter: appfilter) => {
    try {
      const list = await readAppListAPI(appfilter)
      RSStore.appList = list
    } catch (e) {
      console.error("앱 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onUpdateShowApp = async (updateshowapp: updateshowapp) => {
    try {
      const result = await updateShowAppAPI(updateshowapp)
      if (result) {
        console.log("앱 업데이트 완료 :", updateshowapp)
      } else {
        console.log("앱 업데이트 실패 입력값 확인 필요", updateshowapp)
      }
    } catch (e) {
      console.error("앱 업데이트 중 에러 발생:", e)
    }
  }

  const onUpdatenoteApp = async (updatenoteapp: updatenoteapp) => {
    try {
      const result = await updateNoteAppAPI(updatenoteapp)
      if (result) {
        console.log("앱 업데이트 완료 :", updatenoteapp)
      } else {
        console.log("앱 업데이트 실패 입력값 확인 필요", updatenoteapp)
      }
    } catch (e) {
      console.error("앱 업데이트 중 에러 발생:", e)
    }
  }

  const onDeleteApp = async (id: number) => {
    try {
      const result = await deleteAppAPI(id)
      if (result) {
        console.log("앱 삭제 완료 id:", id)
      } else {
        console.log("앱 삭제 실패 id:", id)
      }
    } catch (e) {
      console.error("앱 삭제 중 에러 발생:", e)
    }
  }

  const onApkUpload = async (apkUpload: apkUpload) => {
    try {
      const result = await apkUploadAPI(apkUpload)
      if (result.message === "Success") {
        console.log("APK 업로드 완료 :", apkUpload)
        return result.message
      } else {
        console.log("APK 업로드 실패 입력값 확인 필요", apkUpload)
        return result.message
      }
    } catch (e) {
      console.error("APK 업로드 중 에러 발생:", e)
      return "upload error"
    }
  }

  const onPaginationApp = async (appfilter: appfilter) => {
    try {
      const result = await paginationAppAPI(appfilter) ?? 0
      return result
    } catch (e) {
      console.error("앱 페이지 수 가져오는 중 에러 발생:", e)
    }
  }

  return {
    onReadAppList,
    onUpdateShowApp,
    onUpdatenoteApp,
    onDeleteApp,
    onApkUpload,
    onPaginationApp,
  }
}